import { render, staticRenderFns } from "./DuoJiSalesBangDingGoods.vue?vue&type=template&id=d13dac24&scoped=true"
import script from "./DuoJiSalesBangDingGoods.vue?vue&type=script&lang=js"
export * from "./DuoJiSalesBangDingGoods.vue?vue&type=script&lang=js"
import style0 from "./DuoJiSalesBangDingGoods.vue?vue&type=style&index=0&id=d13dac24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13dac24",
  null
  
)

export default component.exports